// React e hooks
import { useState } from "react";

// Componentes MUI
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

// Estilos
import style from "./signin.module.css";
import "react-toastify/dist/ReactToastify.css";

// Imagens
import logo from "../../images/logoLogin.jpg";

// Navegação
import { useNavigate } from "react-router-dom";

// Rotas e API
import API_ROUTES from "../../utils/endpoints";
import api from "../../utils/api";

// Ícones
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Alertas
import Swal from "sweetalert2";

// Auth context
import { useAuth } from "../../router/route";

function Signin() {
  // Contexto auth
  const { setAuth } = useAuth();

  // States
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigation = useNavigate();

  // Handlers inputs
  const handleChangeUser = (event) => setUser(event.target.value);
  const handleChangePassword = (event) => setPassword(event.target.value);

  // Toggle visualização da senha
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  // Navegação para recuperar senha
  const handleChangePageToRecoverPass = () => navigation("/recoverPass");

  // Login
  const handleLogin = async () => {
    const obj = { username: user, password };

    try {
      const { data } = await api.post(API_ROUTES.LOGIN, obj);

      if (data.code === 200) {
        // Salva dados no localStorage
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("token", data.token);

        // Atualiza contexto auth
        setAuth({
          logged: true,
          loading: false,
          nameUser: data.name,
          type: data.type,
        });

        // Redireciona para home
        navigation("/home");
      } else {
        showError();
      }
    } catch (error) {
      console.error("Erro no login:", error);
      showError();
    }
  };

  // Mensagem de erro
  const showError = () => {
    Swal.fire({
      icon: "error",
      title: "Usuário não encontrado",
      text: "Verifique novamente os dados informados",
      toast: true,
      showConfirmButton: false,
      position: "top-right",
    });
  };

  return (
    <div className={style["App"]}>
      <div className={style["Form"]}>
        <div className={style["Data-Login"]}>
          <div className={style["logo-div"]}>
            <img src={logo} className={style["logo"]} alt="logo" />
          </div>
          <h1 className={style["Title"]}>Login</h1>
          {/* Input usuário */}
          <Box
            component="div"
            sx={{
              "& > :not(style)": {
                width: "100%",
                marginBottom: "1rem",
              },
            }}
          >
            <TextField
              label="Usuário"
              variant="outlined"
              value={user}
              onChange={handleChangeUser}
            />
          </Box>
          {/* Input senha */}
          <Box component="div" sx={{ "& > :not(style)": { width: "100%" } }}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Password</InputLabel>
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={handleChangePassword}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Box>
          {/* Recuperar senha */}
          <p
            className={style["recoverPass"]}
            onClick={handleChangePageToRecoverPass}
          >
            Esqueci Minha Senha
          </p>
          {/* Botão login */}
          <button
            type="button"
            className={style["Button"]}
            onClick={handleLogin}
          >
            Entrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Signin;
